'use client';

import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import type { StatCardData, StatTone } from '../types';

const TONE_STYLES: Record<StatTone, { icon: string; bg: string }> = {
  blue: {
    icon: 'text-blue-600 dark:text-blue-400',
    bg: 'bg-blue-50 dark:bg-blue-950'
  },
  green: {
    icon: 'text-emerald-600 dark:text-emerald-400',
    bg: 'bg-emerald-50 dark:bg-emerald-950'
  },
  amber: {
    icon: 'text-amber-600 dark:text-amber-400',
    bg: 'bg-amber-50 dark:bg-amber-950'
  },
  rose: {
    icon: 'text-rose-600 dark:text-rose-400',
    bg: 'bg-rose-50 dark:bg-rose-950'
  },
  purple: {
    icon: 'text-purple-600 dark:text-purple-400',
    bg: 'bg-purple-50 dark:bg-purple-950'
  },
  cyan: {
    icon: 'text-cyan-600 dark:text-cyan-400',
    bg: 'bg-cyan-50 dark:bg-cyan-950'
  },
  slate: {
    icon: 'text-slate-600 dark:text-slate-300',
    bg: 'bg-slate-100 dark:bg-slate-800'
  },
  indigo: {
    icon: 'text-indigo-600 dark:text-indigo-400',
    bg: 'bg-indigo-50 dark:bg-indigo-950'
  },
  orange: {
    icon: 'text-orange-600 dark:text-orange-400',
    bg: 'bg-orange-50 dark:bg-orange-950'
  }
};

interface DashboardStatCardProps {
  data: StatCardData;
}

export function DashboardStatCard({ data }: DashboardStatCardProps) {
  const tone = TONE_STYLES[data.tone];
  const Icon = data.icon;

  return (
    <Card>
      <CardContent className='flex items-center gap-4 px-5 py-4'>
        <div className='min-w-0 flex-1'>
          <p className='text-muted-foreground text-sm font-medium'>
            {data.label}
          </p>
          <p className='text-2xl font-bold'>
            {typeof data.value === 'number'
              ? data.value.toLocaleString()
              : data.value}
          </p>
          {data.hint ? (
            <p className='text-muted-foreground mt-1 text-xs'>{data.hint}</p>
          ) : null}
        </div>
        <div className={cn('rounded-xl p-3', tone.bg)}>
          <Icon className={cn('h-5 w-5', tone.icon)} />
        </div>
      </CardContent>
    </Card>
  );
}
